import { ActionCreators } from 'exchange-common'
import React from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'

export const Logout = () => {

	const history = useHistory()
	const dispatch = useDispatch()

	dispatch(ActionCreators.User.unload())

	history.goBack()

	return (
		<div>
			Logout
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/components/logout.tsx